var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"operation-container"},[_c('div',{staticClass:"operation-div"},[_c('div',{on:{"click":_vm.packaging}},[_vm._v("打包")])])])}
var staticRenderFns = []

export { render, staticRenderFns }